module.exports = __webpack_public_path__ + "img/p8-p1-yanzi.744d9fc6.png";